import type { PetAnimalStatus } from '../api/pet-verification';
import type { PrettyValue } from '../types/pretty-value';

type PrettyPetAnimalStatus = {
  [key in PetAnimalStatus]: PrettyValue;
};

export const PRETTY_PET_ANIMAL_STATUS: PrettyPetAnimalStatus = {
  household_pet: {
    text: 'Household pet',
  },
  service_animal: {
    text: 'Service animal',
    description:
      'A specially-trained dog or miniature horse that does work to benefit a person with a disability.',
  },
  emotional_support_animal: {
    text: 'Support animal (ESA)',
    description:
      'An animal that does work or provides therapeutic support to a person with a disability.',
  },
};
